import { render, staticRenderFns } from "./homePix.vue?vue&type=template&id=10161816&scoped=true"
import script from "./homePix.vue?vue&type=script&lang=ts"
export * from "./homePix.vue?vue&type=script&lang=ts"
import style0 from "./homePix.vue?vue&type=style&index=0&id=10161816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10161816",
  null
  
)

export default component.exports